 'use client';

import { ArrowRight } from 'lucide-react';
import Link from 'next/link';
import HomeFooter from './HomeFooter';
import { APP_CONSTANTS } from 'packages/frontend/src/constants/app.constants';

interface FinalCTAProps {
  guardianLoginUrl: string;
  visible?: boolean;
}

export function FinalCTA({ guardianLoginUrl, visible = true }: FinalCTAProps) {
  return (
    <div className="bg-[#F5F8F9] mx-2 sm:mx-4 lg:mx-8 rounded-xl">
      {/* CTA Section */}
      {visible && (
        <div className="px-3 xs:px-4 sm:px-6 md:px-8 pt-8 xs:pt-10 sm:pt-12 md:pt-16 lg:pt-20 pb-6 xs:pb-8 sm:pb-12 lg:pb-16">
          <div className="max-w-6xl mx-auto">
            <div className="text-center space-y-4 xs:space-y-5 sm:space-y-6">
              <h2 className="text-2xl xs:text-3xl sm:text-4xl md:text-5xl font-bold text-[#1D2125]">
                Ready to run your school from one {APP_CONSTANTS.APP_NAME}?
              </h2>
              
              <p className="text-sm xs:text-base sm:text-lg text-[#1D2125] leading-relaxed px-2 xs:px-4 sm:px-0">
                See how Nest gives teachers time back and brings your day together.
              </p>

              <div className="flex justify-center items-center pt-3 xs:pt-4">
                <Link
                  href="/contact-us"
                  className="w-full xs:w-full sm:w-auto inline-flex items-center justify-center px-4 xs:px-5 sm:px-6 py-2 xs:py-2.5 bg-[#0D373D] text-white text-sm xs:text-base font-semibold rounded-xl hover:bg-[#0A2A2F] transition-colors duration-300"
                >
                  Request a demo
                  <ArrowRight className="ml-1.5 xs:ml-2 h-3.5 xs:h-4 w-3.5 xs:w-4" />
                </Link>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Divider Line */}
      {visible && (
              <div className="border-t border-[#E5E7EB]"></div>
      )}

      {/* Shared Footer */}
      <HomeFooter />
    </div>
  );
}

